"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImageAndBackgroundImageFade = require("react-image-and-background-image-fade");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.price"));

var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.claim"));

var _gerenciatdUnifiedcomponents4 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.claim-pill"));

var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.inline-components"));

var _gerenciatdUnifiedcomponents6 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

require("./offer.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const isBase64 = img => {
  if (img.includes('base64')) {
    return true;
  }

  return false;
};

const Offer = _ref => {
  let {
    img,
    title,
    titleLevel,
    colorTitle,
    sizeTitle,
    subtitle,
    sizeSubtitle,
    fontTypeSubtitle,
    text,
    claim,
    claimColor,
    claimFont,
    linkItem,
    marked,
    promoLabel,
    promoType,
    promoStyle,
    prices,
    pricesLabel,
    pricesSubLabel,
    pricesSubLabelInline,
    bgColor,
    priceBox,
    hiddenText,
    className,
    segment,
    colorSubtitle,
    promoSize,
    kindTitle
  } = _ref;
  let maxWidthClass = 'smallOfferWidth';

  if (marked) {
    maxWidthClass = 'bigOfferWidth';
  }

  const textCss = hiddenText ? 'Offer_paragraph_hidden' : 'Offer_paragraph';
  const animatedStyle = 'Offer_hideAnimation';
  const titleClass = !priceBox ? 'Offer_content_title-margin' : 'Offer_content_title';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `${animatedStyle} ${priceBox && priceBox.strikePrice ? `Offer Offer_${segment}--border ${maxWidthClass} Offer_bg_${priceBox.promo && priceBox.promo.bgColor || 'purple'} ${className}` : `Offer ${maxWidthClass} Offer_bg_${bgColor} ${className}`}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "Offer_bgImg",
      children: [img && !isBase64(img) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageAndBackgroundImageFade.BackgroundImage, {
        src: img,
        wrapperClassName: "bgImg",
        isResponsive: true,
        lazyLoad: true
      }), img && isBase64(img) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "base64img bgImg",
        style: {
          backgroundImage: `url(${img})`
        }
      }), !img && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "base64img bgImg",
        style: {
          backgroundImage: 'none'
        }
      }), claim && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        className: "Offer_claim",
        label: claim,
        bgColor: claimColor,
        fontType: claimFont
      }), priceBox && priceBox.strikePrice && priceBox.labelPromo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        className: "promo_claim",
        label: priceBox.labelPromo,
        color: priceBox.promo && priceBox.promo.labelColor || 'white',
        borderColor: priceBox.promo && priceBox.promo.labelColor || 'purple',
        bgColor: priceBox.promo && priceBox.promo.labelColor || 'purple',
        size: promoSize,
        segment: "emp"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "Offer_content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
        text: title,
        level: titleLevel,
        kind: kindTitle,
        align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
        color: priceBox && priceBox.strikePrice ? priceBox.promo && priceBox.promo.titleColor || _gerenciatdUnifiedcomponents6.COLOR.WHITE : colorTitle,
        size: sizeTitle,
        fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.BOLD,
        segment: segment,
        className: titleClass
      }), priceBox && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: priceBox.strikePrice ? priceBox.promo ? 'priceBox priceBox--specialOffer baseline' : 'priceBox priceBox--offer baseline' : 'priceBox center',
        children: [priceBox.strikePrice && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: priceBox.promo ? 'strike-price-specialOffer' : 'strike-price-offer',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, priceBox.strikePrice), {}, {
            color: priceBox.strikePrice && priceBox.strikePrice.color || 'white'
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: priceBox.strikePrice ? priceBox.promo ? 'price-offer--specialOffer' : 'price-offer--offer' : 'price-offer',
          children: [priceBox.textPrice && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
            text: priceBox.textPrice.text,
            kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
            align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
            color: priceBox.textPrice.color || 'orchid-dark',
            size: priceBox.textPrice.size,
            fontType: priceBox.textPrice.fontType,
            segment: segment,
            className: "claimTitle"
          }), priceBox.price && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, priceBox.price), {}, {
            color: priceBox.price.color || 'orchid-dark'
          }))]
        })]
      }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
        text: subtitle,
        kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
        align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
        color: priceBox && priceBox.strikePrice ? priceBox.promo && priceBox.promo.titleColor || _gerenciatdUnifiedcomponents6.COLOR.WHITE : colorSubtitle,
        size: sizeSubtitle,
        fontType: fontTypeSubtitle,
        segment: segment,
        className: "subtitle"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "animatedArea",
        children: [text && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
          text: text,
          kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
          align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
          color: _gerenciatdUnifiedcomponents6.COLOR.GREY_4,
          size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION1,
          fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.REGULAR,
          segment: segment,
          className: textCss
        }), promoLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "promo_label",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
            label: promoLabel,
            type: promoType,
            style: promoStyle
          })
        }), pricesLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
          text: pricesLabel,
          kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
          align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
          color: _gerenciatdUnifiedcomponents6.COLOR.GREY_4,
          size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION2,
          fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.REGULAR,
          segment: segment,
          className: "price_title"
        }), prices && prices.map(item => {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents5.default, {
            justify: "normal",
            className: "reducedLineHeight",
            children: [item.strikePrice && item.strikePrice.amount && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, item.strikePrice), {}, {
              className: ""
            })), item.strikePrice && typeof item.strikePrice === 'string' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
              text: item.strikePrice,
              kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.SPAN,
              align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
              color: _gerenciatdUnifiedcomponents6.COLOR.GREY_4,
              size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION1,
              fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.LIGHT,
              segment: segment,
              className: "lineThroughtPrice"
            }), item.price && item.price.amount && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, item.price)), item.price && typeof item.price === 'string' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
              text: item.price,
              kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.SPAN,
              align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
              color: _gerenciatdUnifiedcomponents6.COLOR.ORANGE,
              size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION2,
              fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.LIGHT,
              segment: segment
            }), pricesSubLabelInline && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
              text: pricesSubLabelInline,
              kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
              align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
              color: "movistar-blue-dark",
              size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION2,
              fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.REGULAR,
              segment: segment,
              className: "reducedLineHeight margin-left-0"
            })]
          }, `price_${item.price.amount}`);
        }), pricesSubLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
          text: pricesSubLabel,
          kind: _gerenciatdUnifiedcomponents6.KIND_TEXT.PARAGRAPH,
          align: _gerenciatdUnifiedcomponents6.ALIGN.LEFT,
          color: _gerenciatdUnifiedcomponents6.COLOR.GREY_4,
          size: _gerenciatdUnifiedcomponents6.SIZE.CAPTION3,
          fontType: _gerenciatdUnifiedcomponents6.FONT_TYPE.REGULAR,
          segment: segment,
          className: "reducedLineHeight"
        })]
      })]
    }), linkItem && linkItem.link && linkItem.taggingInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
      link: linkItem.link,
      taggingInfo: linkItem.taggingInfo,
      className: "moreInfo",
      isBlockElement: true
    })]
  });
};

Offer.propTypes = {
  img: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  pricesLabel: _propTypes.default.string,
  pricesSubLabel: _propTypes.default.string,
  pricesSubLabelInline: _propTypes.default.string,
  text: _propTypes.default.string,
  claim: _propTypes.default.string,
  claimColor: _propTypes.default.string,
  link: _propTypes.default.string,
  marked: _propTypes.default.bool,
  promoLabel: _propTypes.default.string,
  promoType: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents4.CLAIMPILL_TYPE)),
  promoStyle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents4.CLAIMPILL_STYLE)),
  prices: _propTypes.default.arrayOf(_propTypes.default.shape({
    price: _propTypes.default.object.isRequired,
    strikePrice: _propTypes.default.object
  })),
  titleLevel: _propTypes.default.number.isRequired,
  kindTitle: _propTypes.default.string.isRequired,
  bgColor: _propTypes.default.string,

  /**
   * {
   *  "info": "Define el componente priceBox que se situa sobre la imagen",
   *  "kind": "both",
   *  "beautifulName": "PriceBox"
   * }
   */
  priceBox: _propTypes.default.shape({
    price: _propTypes.default.object,
    strikePrice: _propTypes.default.object,
    textPrice: _propTypes.default.object
  }),

  /**
   * {
   *  "info": "Define el color del componente title en el array COLOR",
   *  "kind": "both",
   *  "beautifulName": "Color del Título"
   * }
   */
  colorTitle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.COLOR)),

  /**
   * {
   *  "info": "Tamaño del título",
   *  "kind": "both",
   *  "beautifulName": "Tamaño texto"
   * }
   */
  sizeTitle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.SIZE)),

  /**
   * {
   *  "info": "Tamaño del subtítulo",
   *  "kind": "both",
   *  "beautifulName": "Tamaño texto"
   * }
   */
  sizeSubtitle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.SIZE)),

  /**
   * {
   *  "info": "Color subtitle TextInfo",
   *  "kind": "both",
   *  "beautifulName": "Color subtitulo"
   * }
   */
  colorSubtitle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.COLOR)),
  hiddenText: _propTypes.default.bool,

  /**
   * {
   *  "info": "Define la fuente del componente subtitle según los tipos definidos en el array FONT_TYPE",
   *  "kind": "both",
   *  "beautifulName": "Fuente del subtitulo"
   * }
   */
  fontTypeSubtitle: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.FONT_TYPE)),

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents6.SEGMENT)),

  /**
   * {
   *  "info": "Tamaño del promoClaim",
   *  "kind": "both",
   *  "beautifulName": "Tamaño claim"
   * }
   */
  promoSize: _propTypes.default.oneOf((0, _gerenciatdUnifiedcomponents6.convertToOptions)(_gerenciatdUnifiedcomponents3.CLAIM_SIZE))
};
Offer.defaultProps = {
  subtitle: '',
  sizeSubtitle: _gerenciatdUnifiedcomponents6.SIZE.TITLE5,
  text: '',
  claim: '',
  claimColor: _gerenciatdUnifiedcomponents3.CLAIM_COLOR.PURPLE,
  pricesLabel: '',
  pricesSubLabel: '',
  pricesSubLabelInline: '',
  link: '',
  marked: false,
  promoLabel: '',
  promoType: _gerenciatdUnifiedcomponents4.CLAIMPILL_TYPE.PROMO,
  promoStyle: _gerenciatdUnifiedcomponents4.CLAIMPILL_STYLE.INVERSE,
  prices: null,
  bgColor: _gerenciatdUnifiedcomponents6.COLOR.WHITE,
  priceBox: null,
  colorTitle: _gerenciatdUnifiedcomponents6.COLOR.GREEN,
  hiddenText: false,
  fontTypeSubtitle: _gerenciatdUnifiedcomponents6.FONT_TYPE.REGULAR,
  segment: _gerenciatdUnifiedcomponents6.SEGMENT.GP,
  colorSubtitle: _gerenciatdUnifiedcomponents6.COLOR.BLACK,
  sizeTitle: _gerenciatdUnifiedcomponents6.SIZE.CAPTION1,
  promoSize: _gerenciatdUnifiedcomponents3.CLAIM_SIZE.SMALL,
  kindTitle: _gerenciatdUnifiedcomponents6.KIND_TEXT.SPAN,
  titleLevel: _gerenciatdUnifiedcomponents6.HEADING_LEVEL.H1
};
var _default = Offer;
exports.default = _default;

//# sourceMappingURL=index.js.map